<script lang="ts" setup>
import algoliasearch from 'algoliasearch/lite';
import { useSearchStore } from '@/store';

import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';

import SearchBox from '@/components/search/ais/SearchBox.vue';
import RefinementList from '@/components/search/ais/RefinementList.vue';
import ClearRefinements from '@/components/search/ais/ClearRefinements.vue';
import RefinementListCard from '@/components/search/ais/RefinementListCard.vue';
import Pagination from '@/components/search/ais/Pagination.vue';
import BaseButton from '@/components/ui/buttons/BaseButton.vue';

import { ListFilter } from 'lucide-vue-next';

import type { SearchSignatureDocument } from "@upclaim/sdk/src/data-contracts";
import { ref } from 'vue';

const client = algoliasearch(
  'X2I38XQM9R',
  useSearchStore().searchKey?.securedApiKey as string
);

const tabs = [
  { name: 'Recent', href: '#', current: true },
  { name: 'En cours', href: '#', current: false },
  { name: 'Terminées', href: '#', current: false },
  { name: 'Archivées', href: '#', current: false },
]
const hitsPerPage = 50;
const showFilters = ref(false);
</script>
<template>
<div class="w-full p-12 overflow-auto">


  <ais-instant-search :routing="true" :search-client="client" index-name="signature">

    <div class="inline-flex items-center w-full p-4 bg-gray-50 gap-x-4">
      <div class="w-full">
        <SearchBox placeholder="Rechercher une signature..." />
      </div>
      <div class="mt-1">
        <BaseButton text="Filtres" size="md" :type="showFilters ? 'submit' : 'primary'" :icon="ListFilter" @click="showFilters = !showFilters" />
      </div>
    </div>

    <div v-show="showFilters" class="flex text-left gap-x-8">
        <RefinementList attribute="travelAgencyOffice.travelAgency.name" attribute-name="Agence de voyage" />
        <RefinementList attribute="travelAgencyOffice.amadeusOfficeId" attribute-name="Office ID" />
        <RefinementList attribute="agent.email" attribute-name="Agent" size="lg" />
        <RefinementList attribute="travelAgencyCompany.displayName" attribute-name="Entreprise" size="lg" />
    </div>

    <div class="flex pt-4 pb-8 text-left gap-x-8">
        <RefinementListCard attribute="status" attribute-name="Statut" size="lg" />
    </div>

<div class="">
  <div class="px-4 sm:px-0">
            <div class="sm:hidden">
              <label for="question-tabs" class="sr-only">Select a tab</label>
              <select id="question-tabs" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-rose-500">
                <option v-for="tab in tabs" :key="tab.name" :selected="tab.current">{{ tab.name }}</option>
              </select>
            </div>
            <div class="hidden sm:block">
              <nav class="flex divide-x divide-gray-200 rounded-lg shadow isolate" aria-label="Tabs">
                <a v-for="(tab, tabIdx) in tabs" :key="tab.name" :href="tab.href" :aria-current="tab.current ? 'page' : undefined" :class="[tab.current ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700', tabIdx === 0 ? 'rounded-l-lg' : '', tabIdx === tabs.length - 1 ? 'rounded-r-lg' : '', 'group relative min-w-0 flex-1 overflow-hidden bg-white px-6 py-4 text-center text-sm font-medium hover:bg-gray-50 focus:z-10']">
                  <span>{{ tab.name }}</span>
                  <span aria-hidden="true" :class="[tab.current ? 'bg-rose-500' : 'bg-transparent', 'absolute inset-x-0 bottom-0 h-0.5']" />
                </a>
              </nav>
            </div>
          </div>
        <div class="mt-4">
            <h1 class="sr-only">Demandes de signatures</h1>
            <ul role="list" class="space-y-4">
              <ais-hits>
                <template v-slot="{ items } : { items: SearchSignatureDocument[] }">
                  <li v-for="signature in items" :key="signature.id" class="px-4 py-6 bg-white shadow sm:rounded-lg sm:p-6">
                    {{ signature.emailForSignature }}
                    <div>
                      {{ signature.status }}
                      <span v-if="signature.signatureRequestSentAt" class="ml-auto text-xs italic">
                        Il y a {{ formatDistanceToNow(new Date(signature.signatureDate || signature.statusUpdatedAt || signature.signatureRequestSentAt), { locale: fr }) }}
                      </span>
                    </div>
                  </li>
                </template>
              </ais-hits>
            </ul>
          </div>

          <Pagination :page-size=" hitsPerPage " />
        </div>
      </ais-instant-search>
</div>
</template>